export default {
  basic: "'Inter', sans-serif"
};